import { Pipe, PipeTransform } from '@angular/core';
/*
 * Formats the value to decimals
 * Formats a decimal argument that defaults to 0.
 * Usage:
 *   value | decimals:decimals
 * Example:
 *   {{ 2 |  decimals:2}}
 *   formats to: 1024,00
*/

@Pipe({name: 'formatNumber'})
export class FormatNumberPipe implements PipeTransform {
  transform(value: number, decimals: number): number {
    return parseFloat(value.toFixed(2));
  }
}
 
/*
const PADDING = "000000";

@Pipe({ name: "formatNumber" })
export class FormatNumberPipe implements PipeTransform {

  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;

  constructor() {
    // TODO comes from configuration settings
    this.DECIMAL_SEPARATOR = ".";
    this.THOUSANDS_SEPARATOR = ",";
  }

  transform(value: number | string, decimals: number = 2): string {
    let [ integer, fraction = "" ] = (value || "").toString()
      .split(this.DECIMAL_SEPARATOR);

    fraction = decimals > 0
      ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, decimals)
      : "";

    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

    return integer + fraction;
  }

  parse(value: string, decimals: number = 2): string {
    let [ integer, fraction = "" ] = (value || "").split(this.DECIMAL_SEPARATOR);

    integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, "g"), "");

    fraction = parseInt(fraction, 10) > 0 && decimals > 0
      ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, decimals)
      : "";

    return integer + fraction;
  }

}*/